import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    whop?: {
      track: (...args: unknown[]) => void;
      setScope: (...args: unknown[]) => void;
    };
  }
}

/**
 * Fires the Whop "page" tracking event on every client-side route change so
 * SPA navigations are tracked in addition to the initial load (which is
 * handled by the inline pixel in index.html).
 */
const WhopPixel = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && window.whop) {
      window.whop.track("page");
    }
  }, [pathname]);

  return null;
};

export default WhopPixel;
